import { PillsLogo } from '~/components/app-logo';
import pathsConfig from '~/config/paths.config';

/**
 * Simple header for error pages, showing only the logo.
 * Matches the home page header styling (h-14, px-4, border-b)
 */
export function ErrorPageHeader() {
  return (
    <header className="bg-background/80 sticky top-0 z-50 flex h-14 items-center border-b border-zinc-100 px-4 backdrop-blur-md dark:border-zinc-800">
      <PillsLogo showName href={pathsConfig.app.home} />
    </header>
  );
}
